export default __webpack_public_path__ + "static/media/GymTonicHero.32555aa2.png";